export default __webpack_public_path__ + "star-wars.e1cc5343.png";